export default __webpack_public_path__ + "static/media/robo_img_icon.abed362a.svg";